export class RichiestaIscrizioneScolastica {
    id;
    ordineGrado;
    annoCorso;
    isAssegnato;
    comune;
    plessoId;
    indirizzoDiStudioId;
    confermaComunicazioneAssegnazione;
    plesso;
    richiestaId;
}